import { render, staticRenderFns } from "./DelegationNewView.vue?vue&type=template&id=41074a20&scoped=true&"
import script from "./DelegationNewView.vue?vue&type=script&lang=js&"
export * from "./DelegationNewView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41074a20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41074a20')) {
      api.createRecord('41074a20', component.options)
    } else {
      api.reload('41074a20', component.options)
    }
    module.hot.accept("./DelegationNewView.vue?vue&type=template&id=41074a20&scoped=true&", function () {
      api.rerender('41074a20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delegation/DelegationNewView.vue"
export default component.exports